/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {Entity} from '../../core/main.entity';

export class BlockAction extends Entity {
  link?: string = null;
  page?: string = null;
  data?: any = null;
  method?: any = null;
}

